import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _ErrorTypes, _QualityErrorTypes, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { QualityErrorDetails } from "./QualityErrorDetails/QualityErrorDetails";

export const QualityErrorTypes = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityErrorTypes);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalErrors = useModal(`Errores de tipo ${bean.Name}`, MODAL_LG)

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getQualityErrorTypesCatalogPorPropiedades(props, null).then((resp: any) => {
            setLista(resp);
        }).catch(err => {
            toast.error("Error al cargar la lista Tipos de errores");
        });
    };

    const create = () => {
        setBean({
            State: 1,
        });
        setModal({ ...modal, "name": `Agregar Tipo de Error`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updateQualityErrorTypes(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDQualityErrorTypes', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Errores', icono: 'ri-list-check', visible: true, evento: () => { modalErrors.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Lista de Tipos de Errores de Calidad">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Nombre</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`} >Descripción</label>
                                <textarea value={bean.Description} className="form-control" onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.TechnicianName}</strong>
                    </ModalConfirm>

                    <Modal modal={modalErrors.modal} updateModal={modalErrors.setModal} >
                        <QualityErrorDetails idQualityErrorType={bean.IDQualityErrorTypes} />
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}